"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useIsAuthenticated = _interopRequireDefault(require("@sprinx/react-auth/useIsAuthenticated"));

var _UserFavoritesContext = _interopRequireDefault(require("./UserFavoritesContext"));

var _useGetUserFavoritesServiceCall = _interopRequireDefault(require("./useGetUserFavoritesServiceCall"));

var _useAddToUserFavoritesServiceCall = _interopRequireDefault(require("./useAddToUserFavoritesServiceCall"));

var _useRemoveFromUserFavoriteServiceCall = _interopRequireDefault(require("./useRemoveFromUserFavoriteServiceCall"));

var _useResetUserFavoritesServiceCall = _interopRequireDefault(require("./useResetUserFavoritesServiceCall"));

function UserFavoritesProvider(_ref) {
  var children = _ref.children;

  var handlersRef = _react.default.useRef([]);

  var _React$useState = _react.default.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      userFavorites = _React$useState2[0],
      setUserFavorites = _React$useState2[1];

  var isAuth = (0, _useIsAuthenticated.default)();
  var addToUserFavoritesServiceCall = (0, _useAddToUserFavoritesServiceCall.default)();
  var getUserFavoritesServiceCall = (0, _useGetUserFavoritesServiceCall.default)();
  var removeFromUserFavoriteServiceCall = (0, _useRemoveFromUserFavoriteServiceCall.default)();
  var resetUserFavoritesServiceCall = (0, _useResetUserFavoritesServiceCall.default)();

  var addToUserFavorites = _react.default.useCallback(function (products) {
    addToUserFavoritesServiceCall(products).then(function (f) {
      return setUserFavorites(f);
    });
  }, [addToUserFavoritesServiceCall, setUserFavorites]);

  var reloadUserFavorites = _react.default.useCallback(function () {
    getUserFavoritesServiceCall().then(setUserFavorites);
  }, [getUserFavoritesServiceCall, setUserFavorites]);

  var removeFromUserFavorites = _react.default.useCallback(function (products) {
    removeFromUserFavoriteServiceCall(products).then(function (f) {
      return setUserFavorites(f);
    });
  }, [removeFromUserFavoriteServiceCall, setUserFavorites]);

  var resetUserFavorites = _react.default.useCallback(function () {
    resetUserFavoritesServiceCall().then(function (f) {
      return setUserFavorites(f);
    });
  }, [resetUserFavoritesServiceCall, setUserFavorites]);

  _react.default.useEffect(function () {
    handlersRef.current.forEach(function (h) {
      return h(userFavorites);
    });
  }, [userFavorites]);

  _react.default.useEffect(function () {
    if (isAuth) {
      reloadUserFavorites();
    } else {
      setUserFavorites([]);
    }
  }, [isAuth, reloadUserFavorites, setUserFavorites]);

  return /*#__PURE__*/_react.default.createElement(_UserFavoritesContext.default.Provider, {
    value: {
      userFavorites: userFavorites,
      addToUserFavorites: addToUserFavorites,
      reloadUserFavorites: reloadUserFavorites,
      removeFromUserFavorites: removeFromUserFavorites,
      resetUserFavorites: resetUserFavorites,
      addChangeEventListener: function addChangeEventListener(h) {
        handlersRef.current = [].concat((0, _toConsumableArray2.default)(handlersRef.current || []), [h]);
      },
      removeChangeEventListener: function removeChangeEventListener(h) {
        var i = handlersRef.current.findIndex(function (x) {
          return x === h;
        });

        if (i > -1) {
          handlersRef.current = [].concat((0, _toConsumableArray2.default)(handlersRef.current.slice(0, i)), (0, _toConsumableArray2.default)(handlersRef.current.slice(i + 1)));
        }
      }
    }
  }, children);
}

process.env.NODE_ENV !== "production" ? UserFavoritesProvider.propTypes = {
  children: _propTypes.default.node
} : void 0;
UserFavoritesProvider.defaultProps = {
  children: null
};
var _default = UserFavoritesProvider;
exports.default = _default;